






























import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'

/**
 * Campo de texto con selección de fecha
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class DateInput extends Vue {
    /**
     * Etiqueta para el campo de texto
     */
    @Prop({type: String, default: 'Seleccionar fecha'})
    public label: string

    /**
     * Activa o desactiva el componente, al desactivar el control no permitirá
     * al usuario seleccionar fechas
     */
    @Prop({type: Boolean, default: false})
    public disabled: boolean

    /**
     * Fecha mínima que el usuario podrá editar, se acepta el valor 'now',
     * el cual representa la fecha actual
     */
    @Prop({type: String, default: ''})
    public min: string

    /**
     * Fecha actualmente seleccionada
     */
    @Prop({type: [String, Date], default: ''})
    public value: string

    /**
     * Icono mostrado antes del campo de texto
     */
    @Prop({type: String, default: 'event'})
    public prependIcon: string

    @Prop({type: Array, default: () => [] })
    public rules: Array<() => boolean | string>

    /**
     * Si esta activa el campo se mostrará con un tamaño mas pequeño.
     */
    @Prop({type: Boolean, default: false})
    public dense: boolean

    /**
     * Indica si el menu con el datepicker se encuentra activo
     */
    public menu = false
    public date = ''

    /**
     * Observa DateInput.value
     */
    @Watch('value', {deep: true, immediate: true})
    public onValueChange (date: string | Date) {
        if (date instanceof Date) {
            this.date = moment(date).format('YYYY-MM-DD')

            return
        }

        this.date = date
    }

    /**
     * Proporciona al componente datepicker la fecha mínima seleccionable
     * por el usuario
     */
    public get minDate () {
        if (this.min === 'now') {
            return moment().format('YYYY-MM-DD')
        }

        return this.min
    }

    /**
     * Fecha actualmente seleccionada por el usuario, formateada para
     * ser mostrada en el input
     */
    public get formattedDate () {
        if (!this.date) {
            return ''
        }

        return moment(this.date, 'YYYY-MM-DD').format('LL')
    }

    public mounted () {
        // Si no existe ninguna en el momento de montar el componente, se utilizará la fecha
        // mínima seleccionable
        if (!this.date) {
            this.date = this.minDate
        }

        this.date && this.$emit('input', this.date)
    }
}
